import { RadioButtonCircleSelected } from '@finn/design-system/icons/radio-button-circle-selected';
import { cn } from '@finn/ui-utils';

import differences from './differences.json';

const diffs = differences as Record<string, ConfigDiff>;

type ConfigDiff = {
  has_similarity: boolean;
  config_differences: string[];
};

export const Differences = ({
  configId,
  className,
  isFirst,
}: {
  configId: number;
  className?: string;
  isFirst?: boolean;
}) => {
  const diff = diffs[String(configId)];

  return diff ? (
    <div className={cn('body-14-regular', className)}>
      {diff.has_similarity && !isFirst && (
        <div className="mb-1">Alle genannten Merkmale, plus:</div>
      )}
      <table>
        {diff.config_differences.map((item) => {
          return (
            <tr key={item}>
              <td className="table-cell size-4 overflow-hidden pb-1 text-center">
                <RadioButtonCircleSelected className="-ml-2 -mt-0.5 size-2" />
              </td>
              <td>{item}</td>
            </tr>
          );
        })}
      </table>
    </div>
  ) : null;
};
